module.exports = __webpack_public_path__ + "static/img/topbg-on.5115dc33.webp";